<template>
    <div>
        <h5 id="experience-title" class="section">
            Research Experiences
        </h5>
        <el-card :span="18" class="box-card" id="experience">
            <!-- <p class="research">
            Research Assistant | MadAbility Lab, University of Wisconsin-Madison
            </p>
            <p class="research-time">
            August 2023 -- present
            </p>
            <el-divider></el-divider> -->

            <p class="research">
            Research Assistant | Pervasive Interaction Lab, Department of Computer Science and Technology, Tsinghua University
            </p>
            <p class="research-time">
            Advised by Prof. Yuntao Wang and Prof. Yukang Yan, December 2020 -- August 2023
            </p>
            <p class="research-content">
              Worked on designing systems to understand people's behavior and intentions through their physiological signals, including eye gaze and EEG data.
            </p>

            <el-divider></el-divider>

            <p class="research">
            Research Intern | 2022 Mitacs Globalink Research Internship, University of British Columbia
            </p>
            <p class="research-time">
            Advised by Prof. Khalad Hasan, June 2022 -- September 2022
            </p>
            <p class="research-content">
              Designed clutch-free techniques for list scrolling on smartphones to reach higher interaction efficiency and lower effort in screen scrolling scenarios.
            </p>

            <el-divider></el-divider>

            <p class="research">
            Research Intern | 2021 Access Computing Summer Program, University of Washington & Tsinghua University & Microsoft
            </p>
            <p class="research-time">
            Advised by Prof. Yukang Yan and Prof. Yuntao Wang, June 2021 -- September 2021
            </p>
            <p class="research-content">
              Quantified the probability of users noticing the movement inconsistency in virtual reality. <br/>
              Output paper: Modeling the Noticeability of User-Avatar Movement Inconsistency for Sense of Body Ownership Intervention.
            </p>
        </el-card>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ExperiencesSection',
    data() {
      return {
      };
    }
  };
  </script>
  
  <style>
  </style>